var App = (function () {
  'use strict';

  App.copyButton = function( ){
    $('.js-copy-button').click(function() {
      var text = $(this).data('copy');
      var copyTextArea = document.createElement("textarea");
      copyTextArea.value = text;
      document.body.appendChild(copyTextArea);
      copyTextArea.select();
      try {
        var successful = document.execCommand('copy');
      } catch (err) {
        console.log('Oops, unable to copy');
      }
      document.body.removeChild(copyTextArea);
    });
  };

  return App;
})(App || {});
